import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TlsOptions } from '@shared/services/organization-tls-options.service';
import {
  OrganizationSiteService,
  PassTlsClientCert,
  PassTlsClientCerts,
} from '@shared/services/organization-site.service';
import { ToastrService } from '@shared/services/toastr.service';
import { pick } from 'lodash';
import { NgFor, NgIf } from '@angular/common';
import { LabelComponent } from '@shared/components/label/label.component';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-mtls',
  templateUrl: './mtls.component.html',
  styleUrl: './mtls.component.scss',
  imports: [NgIf, LabelComponent, NgSelectComponent, FormsModule, NgFor, TranslatePipe],
})
export class MtlsComponent implements OnChanges {
  @Input({ required: true }) siteName: string;
  @Input({ required: true }) availableTlsOptions: TlsOptions[];
  @Input({ required: true }) config: MtlsConfig;

  constructor(
    private siteApi: OrganizationSiteService,
    private toastr: ToastrService,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.config) {
      if (!this.config.passTlsClientCert) this.config.passTlsClientCert = 'info';
    }
  }

  saveTlsOptions() {
    this.siteApi
      .patchSite(this.siteName, {
        ...pick(this.config, ['tlsOptions', 'passTlsClientCert']),
        tlsOptions: this.config.tlsOptions ? { uid: this.config.tlsOptions.uid } : null,
      })
      .subscribe((site) => {
        const { tlsOptions, passTlsClientCert } = site;
        this.config = { tlsOptions, passTlsClientCert };
        this.toastr.success();
      });
  }

  protected readonly PassTlsClientCerts = PassTlsClientCerts;
}

type MtlsConfig = {
  tlsOptions: TlsOptions;
  passTlsClientCert: PassTlsClientCert;
};
